module.exports = __webpack_public_path__ + "static/media/181CO231.90f643ce.jpg";